import {connect} from 'react-redux';
import RequiredProfileFieldsModal from './RequiredProfileFieldsModal.jsx';
import {
  handleSendToProfile,
  handleRequiredProfileFieldsModalCancel
} from './actions';

const mapStateToProps = state => ({
  visible: state.registration.home.showRequiredProfileFieldsModal,
  message: state.shared.auth.validationMessage
});

const mapDispatchToProps = dispatch => ({
  onSubmit: () => dispatch(handleSendToProfile()),
  onCancel: () => dispatch(handleRequiredProfileFieldsModalCancel())
});

export default connect(mapStateToProps, mapDispatchToProps)(RequiredProfileFieldsModal);



// WEBPACK FOOTER //
// ./src/features/registration/home/RequiredProfileFieldsModalContainer.jsx